export class PaymentMethod {

    id: number;
    details: string;
    typeId: number;
    statusId: number;
    statusUpdatedBy: string;

    constructor(obj?: any) {
        this.id                 = obj && obj.id                 || null;
        this.details            = obj && obj.details            || '';
        this.typeId             = obj && obj.typeId             || null;
        this.statusId           = obj && obj.statusId           || null;
        this.statusUpdatedBy    = obj && obj.statusUpdatedBy    || '';
    }
}



// WEBPACK FOOTER //
// ./src/app/models/payment-method.model.ts